/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "You have obtained business justification for accessing customer data"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "Your download activity will be recorded and tracked for security compliance purposes"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "Do you want to proceed?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "By downloading, you acknowledge that:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
